export const TRADING_MODE_IDS = Object.freeze({
  LIVE: "live",
  PAPER: "paper",
  PAPER_AUTO: "paper-auto",
  AUTO_LIVE: "auto-live",
});

export const TRADING_MODE_POLICIES = Object.freeze({
  [TRADING_MODE_IDS.LIVE]: Object.freeze({
    id: TRADING_MODE_IDS.LIVE,
    label: "LIVE",
    requiredFeature: "professional_trading_center",
    executionEnvironment: "LIVE_MANUAL",
    marketDataPolicy: "AUTHENTICATED_FAIL_CLOSED",
    manualExecutionAllowed: false,
    automatedExecutionAllowed: false,
    liveMoneyAllowed: false,
    locked: false,
    safetyMessage:
      "Live market workspace. Live-money execution is not granted by Trading Center V1 and remains subject to separate broker and authorization gates.",
  }),
  [TRADING_MODE_IDS.PAPER]: Object.freeze({
    id: TRADING_MODE_IDS.PAPER,
    label: "PAPER",
    requiredFeature: "paper_trading",
    executionEnvironment: "PAPER_MANUAL",
    marketDataPolicy: "AUTHENTICATED_FAIL_CLOSED",
    manualExecutionAllowed: true,
    automatedExecutionAllowed: false,
    liveMoneyAllowed: false,
    locked: false,
    safetyMessage:
      "Manual paper execution only. Orders and fills must remain in the paper or local simulation environment; no live-money routing is allowed.",
  }),
  [TRADING_MODE_IDS.PAPER_AUTO]: Object.freeze({
    id: TRADING_MODE_IDS.PAPER_AUTO,
    label: "PAPER AUTO",
    requiredFeature: "paper_autotrade",
    executionEnvironment: "PAPER_AUTOMATED",
    marketDataPolicy: "AUTHENTICATED_FAIL_CLOSED",
    manualExecutionAllowed: true,
    automatedExecutionAllowed: true,
    liveMoneyAllowed: false,
    locked: false,
    safetyMessage:
      "Automated paper execution only. Existing simulated AutoTrade limits and lifecycle controls remain mandatory; no live-money routing is allowed.",
  }),
  [TRADING_MODE_IDS.AUTO_LIVE]: Object.freeze({
    id: TRADING_MODE_IDS.AUTO_LIVE,
    label: "AUTO LIVE",
    executionEnvironment: "LIVE_AUTOMATED_LOCKED",
    marketDataPolicy: "AUTHENTICATED_FAIL_CLOSED",
    manualExecutionAllowed: false,
    automatedExecutionAllowed: false,
    liveMoneyAllowed: false,
    locked: true,
    safetyMessage:
      "LOCKED. Live AutoTrade cannot be enabled until brokerage, compliance, security, audit, risk, testing, and explicit authorization gates are complete.",
  }),
});

export const TRADING_MODE_ORDER = Object.freeze([
  TRADING_MODE_IDS.LIVE,
  TRADING_MODE_IDS.PAPER,
  TRADING_MODE_IDS.PAPER_AUTO,
  TRADING_MODE_IDS.AUTO_LIVE,
]);

export function getTradingModePolicy(modeId) {
  return TRADING_MODE_POLICIES[modeId] || TRADING_MODE_POLICIES[TRADING_MODE_IDS.LIVE];
}

export function canSelectTradingMode(modeId, featureAccess = null) {
  const policy = getTradingModePolicy(modeId);

  if (policy.locked) return false;

  if (!policy.requiredFeature) return true;

  if (!featureAccess) return true;

  return featureAccess[policy.requiredFeature] === true;
}

export function resolveTradingModeFromLegacyPage(pageId) {
  if (pageId === "paper-trading") return TRADING_MODE_IDS.PAPER;
  if (pageId === "paper-autotrade") return TRADING_MODE_IDS.PAPER_AUTO;
  return TRADING_MODE_IDS.LIVE;
}
